export const ERROR_500_URL = '/500'
export const ERROR_404_URL = '/404'

export const DEFAULT_URL = '/'

export const CONTACT_REQUEST_URL = '/request-demo'
export const TERM_OF_SERVICES_URL = '/term-of-services'
export const PRIVACY_POLICY_URL = '/privacy-policy'
export const ATTRACT_SOURCE_URL = '/ats/attract-and-source'
export const TRACK_COLLABORATE_URL = '/ats/track-and-collaborate'
export const HIRE_ANALYTICS_URL = '/ats/hire-and-analyze'
export const FEATURES_URL = '/ats'
export const SOLUTIONS_URL = '/solutions'
export const ABOUT_US_URL = '/about-us'
export const CONTACT_US_URL = '/contact-us'
export const SOLUTIONS_ENTERPRISE_URL = '/solutions/enterprise'
export const SOLUTIONS_RECRUITMENT_AGENCY_URL = '/solutions/recruitment-agency'
export const TALENT_INTELLIGENCE_URL = '/talent-intelligence'
export const TALENT_AI_URL = '/talent-intelligence/talent-ai'

export const HR_OKR_EBOOK_URL = 'https://get.talentsforce.io/hr-okr-ebook'
export const JOB_DESCRIPTIONS_URL =
  'https://get.talentsforce.io/job-descriptions'
export const INTERVIEW_QUESTION_URL =
  'https://get.talentsforce.io/interview-question-template'
export const FACEBOOK_URL = 'https://www.facebook.com/talentsforce.io'
export const LINKEDIN_URL = 'https://www.linkedin.com/company/talentsforce'
export const X_URL = 'https://x.com/talentsforce'
export const PRODUCT_HUNT_URL =
  'https://www.producthunt.com/products/talentsforce'

// Protected Static Pages
export const PAGES_PROTECTED_STATIC: { [key: string]: Array<string> } = {}

// Protected Dynamic Pages
export const URL_TERM_OF_SERVICE = `https://freec-cms.directus.app/items/hireforce_term_and_service`
export const URL_PRIVACY_POLICY = `https://freec-cms.directus.app/items/hireforce_privacy_policy`
export const URL_HELP_CENTER = `https://help.talentsforce.io`
export const URL_LOGIN_APP = `https://app.talentsforce.io/login`
export const URL_REGISTER_APP = `https://app.talentsforce.io/register`
export const URL_BLOG = `https://blog.talentsforce.io/`
